import actionTypes from "../../actions/GeneralAction/actionType";

const general = (
  state = {
    loading: false,
    isActionActive: false,
    showSnackbar: false,
    snackbarMessage: "",
    snackbarSeverity: "success",
    showSideDrawer: false,
    profile: {
      permissions: ["admin"],
    },
    temporaryData: [],
  },
  action
) => {
  switch (action.type) {
    case actionTypes.GET_PROFILE:
      return Object.assign({}, state, {
        profile: action.profile,
      });

    case actionTypes.TOGGLE_ACTION:
      return Object.assign({}, state, {
        isActionActive: action.isActionActive,
      });

    case actionTypes.SAVE_TEMPORARY_DATA:
      return Object.assign({}, state, {
        temporaryData: action.temporaryData,
      });

    case actionTypes.TOGGLE_LOADING:
      return Object.assign({}, state, {
        loading: !state.loading,
      });

    case actionTypes.OPEN_SNACKBAR:
      return Object.assign({}, state, {
        showSnackbar: true,
        snackbarMessage: action.message,
        snackbarSeverity: action.severity,
      });

    case actionTypes.CLOSE_SNACKBAR:
      return Object.assign({}, state, {
        showSnackbar: false,
        snackbarMessage: "",
      });

    case actionTypes.OPEN_SIDEDRAWER:
      return Object.assign({}, state, {
        showSideDrawer: true,
      });

    case actionTypes.CLOSE_SIDEDRAWER:
      return Object.assign({}, state, {
        showSideDrawer: false,
      });

    case actionTypes.PROFILE:
      return Object.assign({}, state, {
        profile: action.payload,
      });

    default:
      return state;
  }
};

export default general;
